import type { SpreadsheetNoteDisplayOptions } from 'components/SpreadsheetNotes/types';

export type SpreadsheetWorkbookPreviewFeatureOptions = {
  columnResize?: boolean;
  rowResize?: boolean;
  search?: boolean;
  stickyReferenceColumn?: boolean;
  stickyReferenceRow?: boolean;
  zoom?: boolean;
};

export type ResolvedSpreadsheetWorkbookPreviewFeatureOptions = Readonly<Required<SpreadsheetWorkbookPreviewFeatureOptions>>;

export const DEFAULT_SPREADSHEET_WORKBOOK_PREVIEW_FEATURE_OPTIONS: ResolvedSpreadsheetWorkbookPreviewFeatureOptions = {
  columnResize: false,
  rowResize: false,
  search: false,
  stickyReferenceColumn: false,
  stickyReferenceRow: false,
  zoom: true,
};

export const INTERACTIVE_XLSX_WORKBOOK_PREVIEW_FEATURE_OPTIONS: ResolvedSpreadsheetWorkbookPreviewFeatureOptions = {
  columnResize: true,
  rowResize: true,
  search: false,
  stickyReferenceColumn: true,
  stickyReferenceRow: false,
  zoom: true,
};

export const FIRM_DOCUMENT_XLSX_WORKBOOK_PREVIEW_FEATURE_OPTIONS: ResolvedSpreadsheetWorkbookPreviewFeatureOptions = {
  ...INTERACTIVE_XLSX_WORKBOOK_PREVIEW_FEATURE_OPTIONS,
  search: true,
  stickyReferenceColumn: false,
  stickyReferenceRow: false,
  zoom: true,
};

export const resolveSpreadsheetWorkbookPreviewFeatureOptions = (
  featureOptions?: SpreadsheetWorkbookPreviewFeatureOptions
): ResolvedSpreadsheetWorkbookPreviewFeatureOptions => ({
  ...DEFAULT_SPREADSHEET_WORKBOOK_PREVIEW_FEATURE_OPTIONS,
  ...featureOptions,
});

export const getSpreadsheetNoteDisplayOptionsFromPreviewFeatures = (
  featureOptions?: SpreadsheetWorkbookPreviewFeatureOptions
): SpreadsheetNoteDisplayOptions => {
  const resolvedFeatureOptions = resolveSpreadsheetWorkbookPreviewFeatureOptions(featureOptions);

  return {
    allowColumnResize: resolvedFeatureOptions.columnResize,
    allowMergedSelectionIndicatorSpan: true,
    allowRowResize: resolvedFeatureOptions.rowResize,
    disableLegendSelection: true,
    enableCopyFeedback: true,
    reserveColumnIndicatorSpace: true,
    resizeHandlesInColumnLegend: resolvedFeatureOptions.columnResize,
    showGridLegends: true,
  };
};
